import { render } from "./AbbreviationSettings.vue?vue&type=template&id=426818b4&scoped=true&ts=true"
import script from "./AbbreviationSettings.vue?vue&type=script&lang=ts"
export * from "./AbbreviationSettings.vue?vue&type=script&lang=ts"

import "./AbbreviationSettings.vue?vue&type=style&index=0&id=426818b4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-426818b4"]])

export default __exports__